import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError, AuthFetchWithResponse } from '@e3dc-react/shell/Types/api'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { InstallationStatusModel } from '../types'
import { InstallationStatusDto } from './dto/installation-status.dto'
import installationStatusToModelTransformer from '../transformers/installation-status-to-model.transformer'

/**
 * Fetches the installation device status. Can be filtered by installation IDs.
 *
 * @param installationIds Array of installation IDs to fetch the status for.
 * @returns A promise that resolves to an ApiResult containing the installation status models or an error.
 */
export const fetchInstallationStatus = async (
  authFetch: AuthFetchWithResponse,
  installationIds: number[]
): Promise<ApiResult<InstallationStatusModel[], AuthFetchError | Error>> => {
  const payload = { iids: JSON.stringify(installationIds) }

  try {
    const response = await authFetch<InstallationStatusDto[]>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: 'installations/status',
      method: 'GET',
      payload,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult(installationStatusToModelTransformer(response.data))
    }
    return new ApiResult<InstallationStatusModel[], AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<InstallationStatusModel[]>(error)
  }
}
